import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Unit } from '@xanadu/model';
import { UnitCache } from '@xanadu/cache';

@Component({
    selector: 'app-unit-panel',
    templateUrl: './unit-panel.component.html',
    styleUrls: ['./unit-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('unit-panel')
export class UnitPanelComponent extends PanelComponent<Unit> {
    private readonly unitCache = inject(UnitCache);

    private tabUnit = { caption: 'Unit', active: true, hidden: false };

    protected override get nodeType(): string | undefined {
        return 'role';
    }

    protected override setup(unit: Unit): void {
        super.setup(unit);

        this.tabs = [
            this.tabUnit
        ];
        this.tabSelected = this.tabUnit;
    }

    protected override refresh(unit: Unit): void {
        super.refresh(unit);

        this.unitCache.update();
    }
}
